import { inject } from '@angular/core';
import { SplashScreenStateService } from '../common/services/splash-screen-state.service';
import { ConfigService } from '../config/services/config.service';
import { Router } from '@angular/router';

export const TermsAndConditionsConfigurationGuard = () => {
    const router = inject(Router);
    const configService = inject(ConfigService);
    const splashScreenStateService = inject(SplashScreenStateService);

    if (configService.config()?.configuration?.features?.termsAndConditions?.enabled) {
        splashScreenStateService.stop();
        return true;
    } else {
        return router.navigate(['/']);
    }
};
